export function initializeNativePlatform() {
    if ('cordova' in global) {
        // Use InAppBrowser
        window.open = (global as any).cordova.InAppBrowser.open
    }
}
